import { UserShort } from "tm-shared/types";

import { StyledNoResults, StyledSectionTitle } from "../../Styled";
import { MemberCard } from "../MemberCard";

interface TeamListProps {
    members: UserShort[];
    teamRoutes: { [userId: string]: string };
    searchQuery: string;
    isProcessing: boolean;
    onLoadSchedule: (
        userId: string,
        roleSlug: string,
        routeId?: string,
    ) => void;
    onNavigate: () => void;
}

export const TeamList = ({
    members,
    teamRoutes,
    searchQuery,
    isProcessing,
    onLoadSchedule,
    onNavigate,
}: TeamListProps) => {
    return (
        <>
            <StyledSectionTitle>Команда ({members.length})</StyledSectionTitle>

            {members.length === 0 && searchQuery && (
                <StyledNoResults>
                    Нічого не знайдено за запитом &quot;{searchQuery}&quot;
                </StyledNoResults>
            )}

            {members.map((member) => (
                <MemberCard
                    key={member.userId}
                    member={member}
                    routeId={teamRoutes[member.userId]}
                    isActive={false}
                    isProcessing={isProcessing}
                    onLoadSchedule={onLoadSchedule}
                    onNavigate={onNavigate}
                />
            ))}
        </>
    );
};
